module.exports = __webpack_public_path__ + "img/00016.5957b97a.webp";